(function(){
  'use strict';
  var CFG = window.EB_SIM || {}; var EN = !!CFG.en;
  var VARIANTS = CFG.variants || {};
  var state = {
    color:'#1b1b1d', colorName: EN ? 'Black' : 'Noir',
    height:'150 cm', fill:'Livré vide',
    logo:null, logoU:0.5, logoV:0.36, logoScale:0.42, logoRot:0,
    logo2:null, logo2U:0.0, logo2V:0.36, logo2Scale:0.42, logo2Rot:0,
    txt:'', txtColor:'#e7e3da', txtColorName: EN ? 'White' : 'Blanc',
    txtU:0.5, txtV:0.62, txtSize:14, txtRot:0
  };

  function heightCm(){ return parseInt(state.height, 10); }
  function variant(){ return VARIANTS[state.height + '|' + state.fill] || null; }
  function refreshPrice(){
    var v = variant();
    document.getElementById('eb-sim-price-val').textContent = v ? (Math.round(v.cents/100) + ' €') : '—';
    document.getElementById('eb-sim-variant').value = v ? v.id : '';
  }
  function refreshProps(){
    document.getElementById('eb-sim-prop-color').value = state.colorName + ' (' + state.color + ')';
    document.getElementById('eb-sim-prop-text').value =
      state.txt ? '« ' + state.txt + ' » — ' + state.txtColorName + ' (' + state.txtColor + ')' : '';
    var subj = EN ? 'Free mock-up - custom heavy bag' : 'Maquette gratuite - sac de frappe personnalise';
    var body = (EN
      ? 'Hello,%0D%0A%0D%0AMy configuration from the 3D configurator:%0D%0A- Height: '
      : 'Bonjour,%0D%0A%0D%0AMa configuration depuis le configurateur 3D :%0D%0A- Hauteur : ')
      + heightCm() + ' cm%0D%0A'
      + (EN ? '- Filling: ' : '- Remplissage : ') + state.fill + '%0D%0A'
      + (EN ? '- Colour: ' : '- Couleur : ') + state.colorName + ' (' + state.color + ')%0D%0A'
      + (state.txt ? ((EN ? '- Text: ' : '- Texte : ') + encodeURIComponent(state.txt) + '%0D%0A') : '')
      + '%0D%0A' + (EN ? 'My logo is attached to this email.' : 'Mon logo est joint à cet email.');
    document.getElementById('eb-sim-cta-mail').href =
      'mailto:info@aspritboxe.com?subject=' + encodeURIComponent(subj) + '&body=' + body;
  }

  function boot(){
    if (!window.THREE) return;
    var canvas = document.getElementById('eb-sim-canvas');
    var stage = canvas.parentElement;
    var renderer = new THREE.WebGLRenderer({canvas:canvas, antialias:true, alpha:true});
    renderer.setPixelRatio(Math.min(window.devicePixelRatio||1, 2));

    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(34, 1, 0.1, 100);

    scene.add(new THREE.AmbientLight(0xffffff, 0.55));
    var key = new THREE.DirectionalLight(0xffffff, 0.85); key.position.set(2.5, 3, 3); scene.add(key);
    var rim = new THREE.DirectionalLight(0xf0c040, 0.25); rim.position.set(-3, 1.5, -2); scene.add(rim);
    var fill2 = new THREE.DirectionalLight(0xffffff, 0.3); fill2.position.set(-2, -1, 2.5); scene.add(fill2);

    var group = new THREE.Group();
    scene.add(group);

    var shC = document.createElement('canvas'); shC.width = shC.height = 256;
    var sg = shC.getContext('2d');
    var grad = sg.createRadialGradient(128,128,10,128,128,120);
    grad.addColorStop(0,'rgba(0,0,0,0.45)'); grad.addColorStop(1,'rgba(0,0,0,0)');
    sg.fillStyle = grad; sg.fillRect(0,0,256,256);
    var shadow = new THREE.Mesh(
      new THREE.PlaneGeometry(1.6,1.6),
      new THREE.MeshBasicMaterial({map:new THREE.CanvasTexture(shC), transparent:true, depthWrite:false})
    );
    shadow.rotation.x = -Math.PI/2;
    scene.add(shadow);

    var texCanvas = document.createElement('canvas');
    texCanvas.width = 2048; texCanvas.height = 2048;
    var tex = new THREE.CanvasTexture(texCanvas);
    tex.anisotropy = renderer.capabilities.getMaxAnisotropy();
    var W = texCanvas.width, H = texCanvas.height, S = W/1024;

    var bodyMat = new THREE.MeshPhongMaterial({map:tex, shininess:24, specular:0x333333});
    var capMat  = new THREE.MeshPhongMaterial({color:0x1b1b1d, shininess:24, specular:0x333333});
    var strapMat= new THREE.MeshPhongMaterial({color:0x1b1b1d, shininess:8});
    var trimMat = new THREE.MeshPhongMaterial({color:0x141414, shininess:10});
    var rivetMat= new THREE.MeshPhongMaterial({color:0x8a7a45, shininess:85, specular:0xbbbbbb});
    function applyColor(){
      capMat.color.set(state.color);
      strapMat.color.set(state.color);
    }

    var parts = null, bagBody = null;
    var raycaster = new THREE.Raycaster();

    var FONT = 'bold %PX%px "Arial Black", "Arial Bold", Impact, sans-serif';

    function imgRect(img, u, v, scale){
      var C = Math.PI*40, Hcm = heightCm();
      var lw = img._w || img.naturalWidth || img.width || 1;
      var lh = img._h || img.naturalHeight || img.height || 1;
      var wcm = C*scale;
      var hcm = wcm*(lh/lw);
      var maxH = Hcm*0.62;
      if (hcm > maxH){ hcm = maxH; wcm = hcm*(lw/lh); }
      return { pw: wcm/C*W, ph: hcm/Hcm*H, cx: u*W, cy: v*H };
    }
    function elemRect(kind, g){
      if (kind === 'logo' && state.logo) return imgRect(state.logo, state.logoU, state.logoV, state.logoScale);
      if (kind === 'logo2' && state.logo2) return imgRect(state.logo2, state.logo2U, state.logo2V, state.logo2Scale);
      if (kind === 'txt' && state.txt) return textRect(g);
      return null;
    }
    function textRect(g){
      var C = Math.PI*40, Hcm = heightCm();
      var ph = state.txtSize/Hcm*H;
      g.font = FONT.replace('%PX%', String(ph));
      var pw = g.measureText(state.txt).width;
      var maxW = (C*0.95)/C*W;
      if (pw > maxW){ ph = ph*maxW/pw; pw = maxW; g.font = FONT.replace('%PX%', String(ph)); }
      return { pw: pw, ph: ph, cx: state.txtU*W, cy: state.txtV*H };
    }

    function drawTexture(){
      var g = texCanvas.getContext('2d');
      g.fillStyle = state.color; g.fillRect(0,0,W,H);
      g.save(); g.globalAlpha = 0.05;
      for (var i=0;i<2600*S*S;i++){
        g.fillStyle = Math.random()>0.5 ? '#ffffff' : '#000000';
        g.fillRect(Math.random()*W, Math.random()*H, 1.4*S, 1.4*S);
      }
      g.restore();
      var dark = 'rgba(0,0,0,0.35)', lite = 'rgba(255,255,255,0.28)';
      [0.25, 0.75].forEach(function(u){
        var x = W*u;
        g.strokeStyle = dark; g.lineWidth = 3*S;
        g.beginPath(); g.moveTo(x,0); g.lineTo(x,H); g.stroke();
        g.strokeStyle = lite; g.lineWidth = 1.2*S; g.setLineDash([7*S,6*S]);
        g.beginPath(); g.moveTo(x+5*S,0); g.lineTo(x+5*S,H); g.stroke();
        g.beginPath(); g.moveTo(x-5*S,0); g.lineTo(x-5*S,H); g.stroke();
        g.setLineDash([]);
      });
      [[state.logo, state.logoU, state.logoV, state.logoScale, state.logoRot],
       [state.logo2, state.logo2U, state.logo2V, state.logo2Scale, state.logo2Rot]
      ].forEach(function(L){
        if (!L[0]) return;
        var r = imgRect(L[0], L[1], L[2], L[3]);
        var rad = L[4]*Math.PI/180;
        [r.cx - W, r.cx, r.cx + W].forEach(function(cx){
          g.save(); g.translate(cx, r.cy); g.rotate(rad);
          g.drawImage(L[0], -r.pw/2, -r.ph/2, r.pw, r.ph);
          g.restore();
        });
      });
      if (state.txt){
        var t = textRect(g);
        var trad = state.txtRot*Math.PI/180;
        g.fillStyle = state.txtColor;
        g.textAlign = 'center'; g.textBaseline = 'middle';
        [t.cx - W, t.cx, t.cx + W].forEach(function(cx){
          g.save(); g.translate(cx, t.cy); g.rotate(trad);
          g.fillText(state.txt, 0, 0);
          g.restore();
        });
      }
      tex.needsUpdate = true;
    }

    function clampElemV(kind){
      var g = texCanvas.getContext('2d');
      var r = elemRect(kind, g);
      if (!r) return;
      var half = Math.max(r.pw, r.ph)/2;
      var min = (H*0.05 + half)/H, max = (H*0.95 - half)/H;
      var key = kind === 'txt' ? 'txtV' : (kind === 'logo2' ? 'logo2V' : 'logoV');
      if (min > max){ state[key] = 0.5; return; }
      state[key] = Math.min(max, Math.max(min, state[key]));
    }

    function buildBag(){
      if (parts){ group.remove(parts); parts.traverse(function(o){ if(o.geometry) o.geometry.dispose(); }); }
      parts = new THREE.Group();
      var R = 0.20, Hm = heightCm()/100;
      bagBody = new THREE.Mesh(new THREE.CylinderGeometry(R,R,Hm,72,1,true), bodyMat);
      bagBody.rotation.y = Math.PI;
      parts.add(bagBody);
      var capTop = new THREE.Mesh(new THREE.SphereGeometry(R,48,20,0,Math.PI*2,0,Math.PI/2), capMat);
      capTop.scale.y = 0.28; capTop.position.y = Hm/2;
      parts.add(capTop);
      var capBot = capTop.clone(); capBot.rotation.x = Math.PI; capBot.position.y = -Hm/2;
      parts.add(capBot);
      var apex = new THREE.Vector3(0, Hm/2 + 0.34, 0);
      var drop = new THREE.Shape();
      drop.moveTo(0, 0.085);
      drop.lineTo(0.042, 0);
      drop.absarc(0, 0, 0.042, 0, Math.PI, true);
      drop.lineTo(0, 0.085);
      var patchGeo = new THREE.ExtrudeGeometry(drop, {depth:0.005, bevelEnabled:true, bevelSize:0.003, bevelThickness:0.002, bevelSegments:2});
      var outlineGeo = new THREE.ExtrudeGeometry(drop, {depth:0.003, bevelEnabled:false});
      var rivetGeo = new THREE.CylinderGeometry(0.007, 0.007, 0.004, 16);
      for (var i=0;i<4;i++){
        var a = i*Math.PI/2 + Math.PI/4;
        var anchor = new THREE.Group();
        anchor.position.set(Math.sin(a)*(R+0.004), Hm/2 - 0.09, Math.cos(a)*(R+0.004));
        anchor.rotation.y = a;
        var outline = new THREE.Mesh(outlineGeo, trimMat);
        outline.position.z = -0.002;
        outline.scale.set(1.16, 1.1, 1);
        var patch = new THREE.Mesh(patchGeo, capMat);
        var tab = new THREE.Mesh(new THREE.BoxGeometry(0.04, 0.105, 0.008), strapMat);
        tab.position.set(0, 0.0425, 0.010);
        var riv1 = new THREE.Mesh(rivetGeo, rivetMat);
        riv1.rotation.x = Math.PI/2;
        riv1.position.set(0, 0.012, 0.017);
        var riv2 = riv1.clone();
        riv2.position.y = -0.024;
        anchor.add(outline); anchor.add(patch); anchor.add(tab); anchor.add(riv1); anchor.add(riv2);
        parts.add(anchor);
        var base = new THREE.Vector3(Math.sin(a)*(R+0.014), Hm/2 + 0.005, Math.cos(a)*(R+0.014));
        var len = base.distanceTo(apex);
        var strap = new THREE.Mesh(new THREE.BoxGeometry(0.04, len + 0.012, 0.008), strapMat);
        strap.position.copy(base).lerp(apex, 0.5);
        strap.lookAt(apex);
        strap.rotateX(Math.PI/2);
        parts.add(strap);
      }
      var loop = new THREE.Mesh(new THREE.TorusGeometry(0.028, 0.009, 10, 28), strapMat);
      loop.position.y = apex.y + 0.02;
      parts.add(loop);
      group.add(parts);
      shadow.position.y = -Hm/2 - 0.02;
      camera.position.set(0, 0.12, 4.85);
      camera.lookAt(0, 0.02, 0);
      clampElemV('logo'); clampElemV('logo2'); clampElemV('txt');
      drawTexture();
    }

    function resize(){
      var w = stage.clientWidth, h = Math.max(stage.clientHeight, 300);
      renderer.setSize(w,h,false);
      camera.aspect = w/h; camera.updateProjectionMatrix();
    }
    resize();
    window.addEventListener('resize', resize);

    function uvAt(e){
      var rect = canvas.getBoundingClientRect();
      var m = new THREE.Vector2(
        ((e.clientX-rect.left)/rect.width)*2-1,
        -((e.clientY-rect.top)/rect.height)*2+1
      );
      raycaster.setFromCamera(m, camera);
      var hits = raycaster.intersectObject(bagBody);
      return hits.length ? hits[0].uv : null;
    }
    function wrapDx(px, cx){
      var dx = px - cx;
      if (dx > W/2) dx -= W;
      if (dx < -W/2) dx += W;
      return dx;
    }
    function hitElem(uv){
      if (!uv) return null;
      var g = texCanvas.getContext('2d');
      var px = uv.x*W, py = (1-uv.y)*H;
      var best = null, bestD = Infinity;
      ['logo', 'logo2', 'txt'].forEach(function(kind){
        var r = elemRect(kind, g);
        if (!r) return;
        var dx = wrapDx(px, r.cx);
        var dy = py - r.cy;
        var half = Math.max(r.pw, r.ph)/2 + 12*S;
        if (Math.abs(dx) <= half && Math.abs(dy) <= half){
          var d = dx*dx + dy*dy;
          if (d < bestD){
            bestD = d;
            var ring = Math.max(Math.abs(dx), Math.abs(dy)) / half;
            best = { kind: kind, cx: r.cx, cy: r.cy, rotate: ring > 0.62 };
          }
        }
      });
      return best;
    }
    var ROTKEY = { logo: 'logoRot', logo2: 'logo2Rot', txt: 'txtRot' };
    function knobFor(kind){
      if (kind === 'logo') return knobLogo;
      if (kind === 'logo2') return knobLogo2;
      return knobTxt;
    }
    function normDeg(a){
      a = ((a + 180) % 360 + 360) % 360 - 180;
      return Math.round(a);
    }

    var dragging=false, movingElem=null, rotElem=null, rotCx=0, rotCy=0, rotStart=0, rotAng0=0, px=0, py=0, tiltX=0;
    canvas.addEventListener('pointerdown', function(e){
      var hit = hitElem(uvAt(e));
      movingElem = null; rotElem = null;
      if (hit && hit.rotate){
        rotElem = hit.kind; rotCx = hit.cx; rotCy = hit.cy;
        rotStart = state[ROTKEY[hit.kind]];
        var uv0 = uvAt(e);
        if (uv0){
          rotAng0 = Math.atan2((1-uv0.y)*H - rotCy, wrapDx(uv0.x*W, rotCx)) * 180/Math.PI;
        }
      } else if (hit){
        movingElem = hit.kind;
      }
      dragging = true; px=e.clientX; py=e.clientY;
      canvas.setPointerCapture(e.pointerId);
    });
    canvas.addEventListener('pointermove', function(e){
      if (!dragging){
        var h = hitElem(uvAt(e));
        canvas.classList.toggle('eb-sim-onlogo', !!(h && !h.rotate));
        canvas.classList.toggle('eb-sim-rotzone', !!(h && h.rotate));
        return;
      }
      if (rotElem){
        var uvr = uvAt(e);
        if (uvr){
          var ang = Math.atan2((1-uvr.y)*H - rotCy, wrapDx(uvr.x*W, rotCx)) * 180/Math.PI;
          state[ROTKEY[rotElem]] = normDeg(rotStart + ang - rotAng0);
          knobFor(rotElem).refresh();
          drawTexture();
        }
      } else if (movingElem){
        var uv = uvAt(e);
        if (uv){
          if (movingElem === 'logo'){ state.logoU = uv.x; state.logoV = (1-uv.y); }
          else if (movingElem === 'logo2'){ state.logo2U = uv.x; state.logo2V = (1-uv.y); }
          else { state.txtU = uv.x; state.txtV = (1-uv.y); }
          clampElemV(movingElem);
          drawTexture();
        }
      } else {
        group.rotation.y += (e.clientX-px)*0.011;
        tiltX = Math.max(-0.35, Math.min(0.35, tiltX + (e.clientY-py)*0.004));
      }
      px=e.clientX; py=e.clientY;
    });
    function endDrag(){ dragging=false; movingElem=null; rotElem=null; }
    canvas.addEventListener('pointerup', endDrag);
    canvas.addEventListener('pointercancel', endDrag);
    canvas.addEventListener('wheel', function(e){
      e.preventDefault();
      camera.position.z = Math.max(1.6, Math.min(7.5, camera.position.z + e.deltaY*0.0022));
    }, {passive:false});

    (function loop(){
      requestAnimationFrame(loop);
      group.rotation.x += (tiltX - group.rotation.x)*0.12;
      renderer.render(scene,camera);
    })();

    document.getElementById('eb-sim-swatches').addEventListener('click', function(e){
      var b = e.target.closest('.eb-sim-sw'); if(!b || b.classList.contains('eb-sim-sw-custom')) return;
      this.querySelectorAll('.eb-sim-sw').forEach(function(x){x.classList.remove('is-active');});
      b.classList.add('is-active');
      state.color = b.getAttribute('data-c');
      state.colorName = b.getAttribute('data-n');
      applyColor(); drawTexture(); refreshProps();
    });
    document.getElementById('eb-sim-heights').addEventListener('click', function(e){
      var b = e.target.closest('button'); if(!b) return;
      this.querySelectorAll('button').forEach(function(x){x.classList.remove('is-active');});
      b.classList.add('is-active');
      state.height = b.getAttribute('data-h');
      buildBag(); refreshPrice(); refreshProps();
    });
    document.getElementById('eb-sim-fill').addEventListener('click', function(e){
      var b = e.target.closest('button'); if(!b) return;
      this.querySelectorAll('button').forEach(function(x){x.classList.remove('is-active');});
      b.classList.add('is-active');
      state.fill = b.getAttribute('data-f');
      refreshPrice(); refreshProps();
    });

    function makeKnob(id, degId, getV, setV){
      var el = document.getElementById(id);
      if (!el) return { refresh: function(){} };
      var ind = el.querySelector('.eb-sim-knob-ind');
      if (!ind){
        ind = document.createElement('span');
        ind.className = 'eb-sim-knob-ind';
        el.appendChild(ind);
      }
      var degEl = document.getElementById(degId);
      if (!degEl){
        degEl = document.createElement('input');
        degEl.type = 'number';
        degEl.className = 'eb-sim-deg';
        el.parentNode.appendChild(degEl);
      }
      function show(){
        var d = getV();
        ind.style.transform = 'rotate(' + d + 'deg)';
        if (document.activeElement !== degEl) degEl.value = Math.round(d);
      }
      degEl.addEventListener('input', function(){
        var v = parseInt(degEl.value, 10);
        if (isNaN(v)) return;
        v = Math.max(-180, Math.min(180, v));
        setV(v);
        ind.style.transform = 'rotate(' + v + 'deg)';
      });
      degEl.addEventListener('blur', show);
      function angleFrom(e){
        var r = el.getBoundingClientRect();
        return Math.round(Math.atan2(e.clientX - (r.left + r.width/2),
                                     -(e.clientY - (r.top + r.height/2))) * 180/Math.PI);
      }
      var on = false;
      el.addEventListener('pointerdown', function(e){
        on = true; el.setPointerCapture(e.pointerId);
        setV(angleFrom(e)); show();
      });
      el.addEventListener('pointermove', function(e){ if(!on) return; setV(angleFrom(e)); show(); });
      el.addEventListener('pointerup', function(){ on = false; });
      el.addEventListener('pointercancel', function(){ on = false; });
      el.addEventListener('dblclick', function(){ setV(0); show(); });
      show();
      return { refresh: show };
    }

    var CIRC = Math.PI*40;
    function showLogoVal(){ var e = document.getElementById('eb-sim-logosize-val'); if (e) e.textContent = Math.round(CIRC*state.logoScale) + ' cm'; }
    function showLogo2Val(){ var e = document.getElementById('eb-sim-logo2size-val'); if (e) e.textContent = Math.round(CIRC*state.logo2Scale) + ' cm'; }
    function showTxtVal(){ var e = document.getElementById('eb-sim-txtsize-val'); if (e) e.textContent = state.txtSize + ' cm'; }

    function readImageFile(f, ok, fail){
      var isSvg = /svg/i.test(f.type) || /\.svg$/i.test(f.name);
      var reader = new FileReader();
      reader.onerror = fail;
      if (isSvg){
        reader.onload = function(){
          var txt = String(reader.result);
          var hasW = /<svg[^>]*\swidth\s*=/i.test(txt), hasH = /<svg[^>]*\sheight\s*=/i.test(txt);
          if (!hasW || !hasH){
            var vb = txt.match(/viewBox\s*=\s*["']\s*[\d.\-]+[\s,]+[\d.\-]+[\s,]+([\d.]+)[\s,]+([\d.]+)/i);
            var w = 1000, h = 1000;
            if (vb){
              var vw = parseFloat(vb[1]), vh = parseFloat(vb[2]);
              if (vw > 0 && vh > 0){ h = Math.round(1000*vh/vw); }
            }
            txt = txt.replace(/<svg/i, '<svg width="'+w+'" height="'+h+'"');
          }
          var img = new Image();
          img.onload = function(){ ok(img); };
          img.onerror = fail;
          img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(txt);
        };
        reader.readAsText(f);
      } else {
        reader.onload = function(){
          var img = new Image();
          img.onload = function(){ ok(img); };
          img.onerror = fail;
          img.src = String(reader.result);
        };
        reader.readAsDataURL(f);
      }
    }
    var UNREADABLE = EN ? 'Unreadable file — try a PNG or JPG' : 'Fichier illisible — essayez un PNG ou un JPG';
    var CHOOSE = EN ? 'Choose a file (PNG, JPG, SVG)' : 'Choisir un fichier (PNG, JPG, SVG)';

    var knobLogo = makeKnob('eb-sim-logoknob', 'eb-sim-logoknob-deg',
      function(){ return state.logoRot; },
      function(d){ state.logoRot = d; drawTexture(); });
    var knobLogo2 = makeKnob('eb-sim-logo2knob', 'eb-sim-logo2knob-deg',
      function(){ return state.logo2Rot; },
      function(d){ state.logo2Rot = d; drawTexture(); });

    document.getElementById('eb-sim-file').addEventListener('change', function(){
      var f = this.files && this.files[0]; if(!f) return;
      readImageFile(f, function(img){
        var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
        if (!w || !h){ document.getElementById('eb-sim-file-label').textContent = UNREADABLE; return; }
        img._w = w; img._h = h;
        state.logo = img;
        state.logoU = 0.5; state.logoV = 0.36; state.logoRot = 0;
        document.getElementById('eb-sim-logosize').value = Math.round(state.logoScale*100);
        document.getElementById('eb-sim-file-label').textContent = f.name;
        showLogoVal(); knobLogo.refresh();
        clampElemV('logo'); drawTexture();
      }, function(){ document.getElementById('eb-sim-file-label').textContent = UNREADABLE; });
    });
    document.getElementById('eb-sim-logosize').addEventListener('input', function(){
      state.logoScale = parseInt(this.value,10)/100;
      showLogoVal(); clampElemV('logo'); drawTexture();
    });
    document.getElementById('eb-sim-logo-center').addEventListener('click', function(){
      state.logoU = 0.5; state.logoV = 0.36; state.logoRot = 0;
      knobLogo.refresh(); clampElemV('logo'); drawTexture();
    });
    document.getElementById('eb-sim-logo-remove').addEventListener('click', function(){
      state.logo = null;
      document.getElementById('eb-sim-file').value = '';
      document.getElementById('eb-sim-file-label').textContent = CHOOSE;
      drawTexture(); refreshProps();
    });
    document.getElementById('eb-sim-logo-dup').addEventListener('click', function(){
      if (!state.logo) return;
      state.logo2 = state.logo;
      state.logo2U = (state.logoU + 0.5) % 1;
      state.logo2V = state.logoV;
      state.logo2Scale = state.logoScale;
      state.logo2Rot = state.logoRot;
      document.getElementById('eb-sim-logo2size').value = Math.round(state.logo2Scale*100);
      document.getElementById('eb-sim-file2-label').textContent =
        EN ? 'Copy of logo 1' : 'Copie du logo 1';
      showLogo2Val(); knobLogo2.refresh();
      clampElemV('logo2'); drawTexture(); refreshProps();
    });

    document.getElementById('eb-sim-file2').addEventListener('change', function(){
      var f = this.files && this.files[0]; if(!f) return;
      readImageFile(f, function(img){
        var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
        if (!w || !h){ document.getElementById('eb-sim-file2-label').textContent = UNREADABLE; return; }
        img._w = w; img._h = h;
        state.logo2 = img;
        state.logo2U = 0.0; state.logo2V = 0.36; state.logo2Rot = 0;
        document.getElementById('eb-sim-logo2size').value = Math.round(state.logo2Scale*100);
        document.getElementById('eb-sim-file2-label').textContent = f.name;
        showLogo2Val(); knobLogo2.refresh();
        clampElemV('logo2'); drawTexture(); refreshProps();
      }, function(){ document.getElementById('eb-sim-file2-label').textContent = UNREADABLE; });
    });
    document.getElementById('eb-sim-logo2size').addEventListener('input', function(){
      state.logo2Scale = parseInt(this.value,10)/100;
      showLogo2Val(); clampElemV('logo2'); drawTexture();
    });
    document.getElementById('eb-sim-logo2-center').addEventListener('click', function(){
      state.logo2U = 0.0; state.logo2V = 0.36; state.logo2Rot = 0;
      knobLogo2.refresh(); clampElemV('logo2'); drawTexture();
    });
    document.getElementById('eb-sim-logo2-remove').addEventListener('click', function(){
      state.logo2 = null;
      document.getElementById('eb-sim-file2').value = '';
      document.getElementById('eb-sim-file2-label').textContent = CHOOSE;
      drawTexture(); refreshProps();
    });

    document.getElementById('eb-sim-text').addEventListener('input', function(){
      state.txt = this.value.toUpperCase().trim();
      clampElemV('txt'); drawTexture(); refreshProps();
    });
    document.getElementById('eb-sim-txtcolors').addEventListener('click', function(e){
      var b = e.target.closest('.eb-sim-sw'); if(!b || b.classList.contains('eb-sim-sw-custom')) return;
      this.querySelectorAll('.eb-sim-sw').forEach(function(x){x.classList.remove('is-active');});
      b.classList.add('is-active');
      state.txtColor = b.getAttribute('data-c');
      state.txtColorName = b.getAttribute('data-n');
      drawTexture(); refreshProps();
    });
    var knobTxt = makeKnob('eb-sim-txtknob', 'eb-sim-txtknob-deg',
      function(){ return state.txtRot; },
      function(d){ state.txtRot = d; drawTexture(); });
    document.getElementById('eb-sim-txtsize').addEventListener('input', function(){
      state.txtSize = parseInt(this.value,10);
      showTxtVal(); clampElemV('txt'); drawTexture();
    });
    document.getElementById('eb-sim-txt-vertical').addEventListener('click', function(){
      state.txtRot = (state.txtRot === -90) ? 0 : -90;
      knobTxt.refresh();
      clampElemV('txt'); drawTexture();
    });
    document.getElementById('eb-sim-txt-center').addEventListener('click', function(){
      state.txtU = 0.5; state.txtV = 0.62; state.txtRot = 0;
      knobTxt.refresh();
      clampElemV('txt'); drawTexture();
    });

    var form = document.getElementById('eb-sim-form');
    var submitting = false;
    form.addEventListener('submit', function(e){
      if (submitting) return;
      var btn = document.getElementById('eb-sim-add');
      var shot = document.getElementById('eb-sim-prop-shot');
      var fileInp = document.getElementById('eb-sim-file');
      if (!fileInp.files || !fileInp.files.length) fileInp.removeAttribute('name');
      else fileInp.setAttribute('name', 'properties[Logo]');
      var file2 = document.getElementById('eb-sim-file2');
      var note2 = document.getElementById('eb-sim-prop-logo2');
      var KEY2 = EN ? 'properties[Logo 2]' : 'properties[Logo 2]';
      if (file2.files && file2.files.length){
        file2.setAttribute('name', KEY2);
        note2.removeAttribute('name');
      } else if (state.logo2){
        file2.removeAttribute('name');
        note2.setAttribute('name', KEY2);
        note2.value = EN ? 'same as logo 1 (see 3D preview for placement)' : 'identique au logo 1 (voir aperçu 3D pour le placement)';
      } else {
        file2.removeAttribute('name');
        note2.removeAttribute('name');
      }
      var txtProp = document.getElementById('eb-sim-prop-text');
      if (!txtProp.value) txtProp.removeAttribute('name');
      var flat = document.getElementById('eb-sim-prop-flat');
      if (!window.DataTransfer || !canvas.toBlob){
        shot.removeAttribute('name');
        if (flat) flat.removeAttribute('name');
        return;
      }
      e.preventDefault();
      submitting = true;
      btn.disabled = true;
      captureShot(function(shotBlob){
        attachFile(shot, shotBlob, 'apercu-3d.png');
        texCanvas.toBlob(function(flatBlob){
          attachFile(flat, flatBlob, EN ? 'print-layout.png' : 'plan-marquage.png');
          form.submit();
        }, 'image/png');
      });
    });
    function attachFile(inp, blob, name){
      if (!inp) return;
      try {
        if (blob){
          var dt = new DataTransfer();
          dt.items.add(new File([blob], name, {type:'image/png'}));
          inp.files = dt.files;
        } else { inp.removeAttribute('name'); }
      } catch(err){ inp.removeAttribute('name'); }
    }
    function captureShot(cb){
      var sz = new THREE.Vector2();
      renderer.getSize(sz);
      renderer.setSize(1280, 1600, false);
      camera.aspect = 1280/1600; camera.updateProjectionMatrix();
      renderer.render(scene, camera);
      canvas.toBlob(function(b){
        renderer.setSize(sz.x, sz.y, false);
        camera.aspect = sz.x/sz.y; camera.updateProjectionMatrix();
        renderer.render(scene, camera);
        cb(b);
      }, 'image/png');
    }
    var dlBtn = document.getElementById('eb-sim-download');
    if (dlBtn) dlBtn.addEventListener('click', function(){
      if (!canvas.toBlob) return;
      captureShot(function(b){
        if (!b) return;
        var a = document.createElement('a');
        a.href = URL.createObjectURL(b);
        a.download = EN ? 'my-custom-bag.png' : 'mon-sac-personnalise.png';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(function(){ URL.revokeObjectURL(a.href); }, 4000);
      });
    });

    var hAct = document.querySelector('#eb-sim-heights .is-active');
    if (hAct && hAct.getAttribute('data-h')) state.height = hAct.getAttribute('data-h');
    var fAct = document.querySelector('#eb-sim-fill .is-active');
    if (fAct && fAct.getAttribute('data-f')) state.fill = fAct.getAttribute('data-f');
    applyColor(); buildBag(); refreshPrice(); refreshProps();
    showLogoVal(); showLogo2Val(); showTxtVal();
  }

  function loadThree(){
    if (window.THREE){ boot(); return; }
    var s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
    s.onload = boot;
    document.head.appendChild(s);
  }
  if ('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(en){
      if (en[0].isIntersecting){ io.disconnect(); loadThree(); }
    }, {rootMargin:'300px'});
    io.observe(document.getElementById('eb-sim-wrap'));
  } else { loadThree(); }
})();
